module.exports = __webpack_public_path__ + "static/media/active-currency.26446acb.svg";